import { useRef } from 'react';
/**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
/**
 * Handles typeahead interactions with collections.
 */ export function useTypeSelect(options) {
    const { keyboardDelegate, selectionManager, onTypeSelect } = options;
    const state = useRef({
        search: '',
        timeout: undefined
    }).current;
    const onKeyDown = (e)=>{
        var _keyboardDelegate_getKeyForSearch;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const character = getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) {
            return;
        }
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) {
                e.stopPropagation();
            }
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = (_keyboardDelegate_getKeyForSearch = keyboardDelegate.getKeyForSearch) === null || _keyboardDelegate_getKeyForSearch === void 0 ? void 0 : _keyboardDelegate_getKeyForSearch.call(keyboardDelegate, state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) {
            var _keyboardDelegate_getKeyForSearch1;
            key = (_keyboardDelegate_getKeyForSearch1 = keyboardDelegate.getKeyForSearch) === null || _keyboardDelegate_getKeyForSearch1 === void 0 ? void 0 : _keyboardDelegate_getKeyForSearch1.call(keyboardDelegate, state.search);
        }
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) {
                onTypeSelect(key);
            }
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = '';
        }, TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) {
        return key;
    }
    return '';
}

//# sourceMappingURL=useTypeSelect.js.map